module.exports = __webpack_public_path__ + "static/media/SlatePro.f03203a1.woff";